'use client';

import { useRouter } from 'next/navigation';
import React, { useState } from 'react';

interface SearchProps {
  title: string;
  placeholder: string;
  buttonText: string;
  searchUrl: string;
}

const Search: React.FC<SearchProps> = ({ title, placeholder, buttonText, searchUrl }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const router = useRouter();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const encodedQuery = encodeURIComponent(searchQuery);
    const fullUrl = `${searchUrl}?query=${encodedQuery}`;
    router.push(fullUrl);
  };

  return (
    <section className="rh-search bg-white py-12 sm:py-24" id="search">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="">
          <h2 className="rh-lg mb-8 max-w-2xl" dangerouslySetInnerHTML={{ __html: title }} />
        </div>
        <div className="max-w-5xl">
          <form id="program-search-form" onSubmit={handleSubmit} className="relative">
            <div className="relative">
              <label
                htmlFor="search-input"
                className="absolute left-6 sm:left-10 top-5 text-base sm:text-xl font-normal text-default-600"
              >
                search query
              </label>
              <input
                id="search-input"
                type="text"
                placeholder={placeholder}
                value={searchQuery}
                onChange={e => setSearchQuery(e.target.value)}
                className="w-full pt-10 pb-4 sm:pt-14 sm:pb-6 px-6 sm:px-10 pr-36 sm:pr-48 rounded-full border-2 border-default-200 transition-shadow duration-200 focus:outline-none focus:ring-2 focus:ring-default-300 focus:border-transparent text-xl"
              />
              <button
                type="submit"
                className="rh-btn-black-lg absolute right-6 top-1/2 transform -translate-y-1/2"
              >
                {buttonText}
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Search;
